<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/EJYgmr/tc-custom/9798891555419.jpg?1718182737772" alt="This image is the cover for the book Silicon Minds"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Silicon Minds
      </h1>
      <p class="bookDescription body article font2">
        <p style='margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;font-size:15px;font-family:"Aptos",sans-serif;'><span style='font-size:16px;font-family:"Times New Roman",serif;'>The book <em>Silicon Minds: Tales from the Frontiers of Artificial Intelligence</em> contains three short stories following the activities of a group called the D.A.W.N. (Digital Aged World Nexus)—consisting of hackers, activists, and rebels. The stories revolve around their efforts to challenge the dominance of the tech company GDC and expose its dark secrets, exploring themes such as identity, power, and the ethics of hacking in a digital age. The tales involve characters like a journalist, a hacker, a security agent, and a scientist, whose lives intersect and intertwine as they question the role of technology in society and contemplate the future of humanity.</span></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Nate Monroe
      </h2>
      
      <p class="authorDescription body article"><p style='margin-top:0cm;margin-right:0cm;margin-bottom:7.95pt;margin-left:.5pt;text-align:justify;font-size:15px;font-family:"Calibri",sans-serif;color:black;margin:0cm;'><span style='font-family:"Times New Roman",serif;color:windowtext;'>Nate Monroe is a prolific author of short stories that explore the themes of artificial intelligence, human nature, and the future. His works include <em>E.V.E. Experimental Variable Entity</em>, <em>The Awakening (The Dawn of Artificial Intelligence and the Contemporary World)</em>, <em>SAM</em>, <em>The UPGRADE (Enhancing Human Intelligence through Artificial Intelligence)</em>, and <em>Sentient Augmented Machine</em>, which are available on [Booksie]. He also wrote <em>In A Flash of Light</em>, which can be read on [Short Story Lovers]. He is passionate about storytelling and examining the human condition through different perspectives. He was born and raised in Detroit, MI, where he developed a love for science fiction, history, and literature. Throughout his human experience, he has served humanity in many ways. As a carpenter in his early years, he built and remodelled homes. As a studio engineer, he professionally recorded, mixed, and mastered audio for countless local artists. He also served as a computer and weapons specialist in the U.S. Army, where he wrote the official arms room policy for the 97th Civil Affairs BN (Airborne). He is an avid reader and a practitioner of introspection. He loves to hear from his readers and appreciates their feedback and questions. His latest publication, <em>The Amnesia of Humanity &ndash; 720 Degrees</em>, is a novel that challenges the notions of reality and identity, and it can be purchased on [Amazon].</span></p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?37a8a814